<template>
  <div class="c-site-search">
    <div class="o-search-box columns small-12 medium-11 large-10 medium-centered">
      <div class="o-search-box__search-results-text-container row" v-if="keywords">
        <h3 class="o-search-box__search-results-text h-alt h-lower columns">
          {{filteredList.length }} result for:
          “ {{keywords}} ”
        </h3>
      </div>

      <div class="o-search-box__search-area row">
        <div class="o-search-box__search-item columns small-8 medium-6 large-4">
          <label class="e-input-label" for="search-text"></label>
          <input @keyup="filterAll" v-model="keywords" id="search-text" class="e-input keyword" type="text" name="search" placeholder="Search Visit Waterford">
        </div>
        <div class="o-search-box__search-item columns small-4 medium-2 end">
          <button @click="resetAllFilters" class="button search-button" type="button"><span class="button__text">Clear</span></button>
        </div>
      </div>

      <div class="o-search-box__filter-area row" style="margin-bottom:30px;">

        <div class="o-search-box__search-item columns small-7 medium-3 ">
          <div class="e-input search e-input--dropdown">
            <select class="e-input--dropdown-select" name="view" v-model="perPage">
              <option v-for="value in perPageValues" :value="value.slug">
                {{ value.name }}
              </option>
            </select>
            <div class="e-input--dropdown__arrow"></div>
          </div>
        </div>

        <div class="o-search-box__search-item columns small-5 medium-3 ">
          <div class="e-input search e-input--dropdown">
            <select v-model="sortMethod" class="o-listing-filter__filter-large-select no-background">
                <option value="none" disabled selected>Sort By</option>
                <option v-for="method in sortMethods" :value="method.slug">
                  {{ method.name }}
                </option>
            </select>
            <div class="e-input--dropdown__arrow"></div>
          </div>
        </div>

        <div class="o-search-box__search-item hide-for-small-only columns medium-6 large-5">
          <div class="row">
            <div class="o-pagination columns">
              <paginate-links
                class="o-pagination__pages c-block pagination top-of-page-pagination"
                for="search"
                :show-step-links="true"
                :limit="3"
                :hide-ellipsis ="true"
                :step-links="{
                  next: '>',
                  prev: '<'
                }"
                :async="true"
                @change="backToTop"
                :classes="{
                'li': 'o-pagination__page',
                }"
              ></paginate-links>
            </div>
          </div>

            </div>
        </div>

    <!-- Grid View -->
    <div class="column small-12">
      <paginate
        :list="filteredList"
        :per="perPage"
        :ellipsis-text ="false"
        :hide-ellipsis ="true"
        class="row small-up-1"
        v-if="(filteredList.length && viewType === 'grid')"
        name="search">
          <div
            class="columns column-block"
            :key="index"
            v-for="(post, index) in paginated('search')">
            <search-tile :post="post" :url="siteAddress" :view-type="'grid'"></search-tile>
          </div>
      </paginate>
    </div>


    <!-- List View -->
    <!-- <paginate
      :list="filteredList"
      :per="perPage"
      class="row"
      v-if="(filteredList.length && viewType === 'list')"
      name="search">
        <div
          class="columns small-12"
          :key="index"
          v-for="(post, index) in paginated('search')">
          <search-tile :post="post" :url="siteAddress" :view-type="'list'"></search-tile>
        </div>
    </paginate> -->

    <div v-if="filteredList.length < 24">
    </div>
    <div v-else>
      <div class="o-search-box__search-item columns small-12 hide-for-small-only">
        <div class="row">
          <div class="o-pagination columns">
            <div class="c-pagination c-pagination--vue" style="margin: 0 auto">
              <paginate-links
                class="o-pagination__pages "
                for="search"
                :show-step-links="true"
                :hide-ellipsis ="true"
                :async="true"
                :limit="3"
                @change="backToTop"
                v-if="filteredList.length"
                :classes="{
                'li': 'o-pagination__page',
                }"
              ></paginate-links>
            </div>
          </div>
        </div>
      </div>
      <div class="o-search-box__search-item columns small-12 show-for-small-only">
        <div class="row">
          <div class="o-pagination columns">
            <div class="c-pagination c-pagination--vue" style="margin: 0 auto">
              <paginate-links
                class="o-pagination__pages "
                for="search"
                :hide-ellipsis ="true"
                :show-step-links="true"
                :async="true"
                :limit="2"
                @change="backToTop"
                v-if="filteredList.length"
                :classes="{
                'li': 'o-pagination__page',
                }"
              ></paginate-links>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Searching -->
    <div class="row" id="c-site-search-no-results" v-if="searched == false">
      <div class="columns small-12">
        <h2 class="c-site-search-no-results__title">
          Searching...
        </h2>
      </div>
    </div>
    <!-- No Results -->
    <div class="row" id="c-site-search-no-results" v-if="filteredList.length < 1 && searched == true">
      <div class="columns small-12">
        <h2 class="c-site-search-no-results__title">
          Sorry, but nothing matched your search terms. Please try again with some different keywords.
        </h2>
      </div>
    </div>

  </div>
  </div>
</template>


<script>
  import axios from 'axios';
  import collect from 'collect.js';
  import SearchTile from './vue-partials/search-tile.vue';

  export default {

    name: 'SiteSearch',

    props: {
      trips: {
        type: Array
      },
      archives: {
        type: Array
      },

      members: {
        type: Array
      },
      searchQuery: {
        type: String
      },
      siteUrl: {
        type: String
      }
    },

    data () {
      return {
        /**
        * How many to display per page
        * This can be changed and pagination updated on the fly
        * @type {Number}
        */
        perPage: 25,

        /**
        * The available perpage values - displayed in the perpage select
        * @type {Obj}
        */
        perPageValues: [
          {
            'name': 'View 5 per page',
            'slug': 5,
            'desc': 'Display 5 per page'
          },
          {
            'name': 'View 10 per page',
            'slug': 10,
            'desc': 'Display 10 per page'
          },
          {
            'name': 'View 15 per page',
            'slug': 15,
            'desc': 'Display 15 per page'
          },
          {
            'name': 'View 25 per page',
            'slug': 25,
            'desc': 'Display 25 per page'
          },
          {
            'name': 'View 50 per page',
            'slug': 50,
            'desc': 'Display 50 per page'
          },
          {
            'name': 'View 75 per page',
            'slug': 75,
            'desc': 'Display 75 per page'
          },
          {
            'name': 'View 100 per page',
            'slug': 100,
            'desc': 'Display 100 per page'
          }
        ],

        /**
        * What list do we paginate
        * @type {Array}
        */
        paginate: ['search'],

        /**
        * Bound to our search input
        * @type {String}
        */
        keywords: '',

        /**
        * Will be generated from the passed in experiences
        * @type {Array}
        */
        categories: [],

        /**
        * The selected category - bound to the cateogory select
        * @type {String}
        */
        category: '',

        /**
        * The available view types - displayed in the view select
        * @type {Obj}
        */
        viewTypes: [
          {
            'name': 'Grid View',
            'slug': 'grid',
            'desc': 'Display in grid view'
          },
          {
            'name': 'List View',
            'slug': 'list',
            'desc': 'Display in list view'
          }
        ],

        /**
        * The selected view type - bound to the view select
        * @type {String}
        */
        viewType: '',

        /**
        * This will contain our initial lists, concatenated together
        * @type {Array}
        */
        initialList: [],

        /**
        * This will contain our filtered experiences
        * @type {Array}
        */
        filteredList: [],

        /**
        * This lets us know if the list has been filtered
        * @type {Boolean}
        */
        searched: false,

        // Site URL to pass to prop
        siteAddress: '',
        /**
        * The selected sort method - bound to the sort select
        * @type {String}
        */
        sortMethods: [
          {
            'name': 'A-Z',
            'slug': 'a-z',
            'desc': 'Sort alphabetically a-z ascending'
          },
          {
            'name': 'Z-A',
            'slug': 'z-a',
            'desc': 'Sort alphabetically z-a descending'
          },
          {
            'name': 'Newest',
            'slug': 'newest-first',
            'desc': 'Sort by date descending'
          },
          {
            'name': 'Oldest',
            'slug': 'oldest-first',
            'desc': 'Sort by date ascending'
          }
        ],
        /**
        * The selected sort method - bound to the sort select
        * @type {String}
        */
        sortMethod: '',

        // Events list, populated by REST API
        eventsList: [],

        // API Url for tribe events posts
        apiUrl: '/wp-json/tribe/events/v1/events/',

      };
    },

    computed:{
    },

    watch: {
      // we want to watch the category and keywords variables
      // and call `filterAll()` on either of them changing
      // this will ensure both filters are applied
      category () {
        this.filterAll();

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      keywords () {
        this.filterAll();

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      // May need to rejig foundation and / or isotope etc..
      viewType () {
        this.$nextTick(() => {
          this.callFoundation();
        });
      },
      sortMethod () {
        this.sortFilteredList();

        this.$nextTick(() => {
          this.callFoundation();
        });
      }
    },

    created () {

      let vmSearch = this;

      // Fetch Tribe Events Posts upon component creation

      axios.get( window.location.protocol + this.apiUrl + '?page=1&per_page=100')
        .then(response => {

          // Set event list to the response
          vmSearch.eventsList = response.data.events;

          // Add the post type and filterable categories to the response data
          vmSearch.eventsList.forEach(function(event) {

            let filterable_categories_list = {
              'link': vmSearch.siteUrl + '/events/',
              'name': 'Festivals',
              'slug': 'festivals'
            };

            // Setup a blank array to hold our searchable items
            let keyword_categories = [];

            // Push the title initially
            keyword_categories.push(event.title);

            // Loop through this event's categories
            $.each(event.categories, function( i, v) {
              // Push each category name
              keyword_categories.push(v.name);
            });

            keyword_categories = keyword_categories.toString();

            // Assign new keyword_search value
            event.keyword_search = keyword_categories;

            event.filterable_categories = [filterable_categories_list];

            event.post_type = 'tribe_events';
          });

          // Once next tick is ready, complete initial setup
          vmSearch.$nextTick(() => vmSearch.doInitialSetup());
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mounted () {


    },

    methods: {

      doInitialSetup () {
        // Set initial list that will not be modified later
        // this.initialList = this.trips;
        this.initialList = this.eventsList.concat(this.members).concat(this.trips).concat(this.archives);
        // console.log(this.archives);
        // this.initialList = this.eventsList.concat(this.trips).concat(this.archives);



        // console.log('Trips: '+this.trips);

        // Get categories from initial Lists
        // this.categories = this.getCategoriesFromAllPosts();

        this.$nextTick(() => {
          this.getCategoriesFromAllPosts()
        })

        // Reset app on mounted
        this.resetAllFilters();

        this.siteAddress = this.siteUrl;

        // Set initial View Type
        this.viewType = 'grid';

        // Assign search query after app reset
        if ( this.searchQuery !== "" ) {
          this.keywords = this.searchQuery;
        }
      },

      // Renit foundation components
      callFoundation () {
        this.$nextTick(() => {
          $(this.$el).foundation();
          // Foundation.reInit('data-accordion')
        })
      },

      // Scroll to top on page change
      backToTop () {
        var target = $('.experience-filter-top');
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
        $('html,body').animate({
          // the 100 is a fixed header offset
            scrollTop: target.offset().top - 130
        }, 500);
          return false;
        }
      },

      /**
      * Filter everything
      * @return {void}
      */
      filterAll () {
        // reset the list to all posts first
        this.filteredList = this.initialList;
        this.filterByCategory();
        this.filterByKeywords();
        this.searched = true;
      },

      /**
      * Reset the list back to it's initial state
      * This will trigger the filters and show everything
      * @return {void}
      */
      resetAllFilters () {
        this.callFoundation();

        this.filteredList = this.initialList;
        this.category = 'all'; // initial state is to show all categories
        this.location = 'all'; // initial state is to show all locations
        this.keywords = ''; // initial state is to show all posts
        this.viewType = 'grid'; // inital state is the grid view type
        this.perPage = 25; // inital state is to show 25 per page
        this.sortMethod = 'newest-first'; // initial state is newest first
      },

      /**
      * Go through the supplied post list and get the categories
      * @return {array}
      */
      getCategoriesFromAllPosts () {

        this.$nextTick(() => {

          let categories = this.initialList.map(post => {

            return post.filterable_categories.map(cat => {
              return cat;
            });
          });

          // horrible name, horrible, but we need to flatten those categories
          // Haha flat kitties, only kidding, we love cats here.
          let flatCats = [].concat.apply([], categories);

          // Generate unique objects
          flatCats = flatCats.filter((obj, pos, arr) => {
            return flatCats.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
          });

          flatCats = flatCats.sort(function( a, b ){
            return a.name > b.name ? 1 : -1;
          });

          this.categories = flatCats;

          // return categories;
        });
      },

      /**
      * Filter the list from the free text search
      * Nothing too fancy, but it works
      * @return {void}
      */
      filterByKeywords () {
        if (!this.keywords) {
          return;
        }

        this.filteredList = this.filteredList.filter(searchItem => {

          let searchItemName = searchItem.title.toLowerCase()
                                   .replace(/[^a-z0-9\s]/gi, '')
                                   .replace(/s\b/gi, '');
          let searchQuery = this.keywords.toLowerCase()
                                         .replace(/[^a-z0-9\s]/gi, '')
                                         .replace(/s\b/g, '');

          if (searchQuery !== '') {
            this.resetVisible = true;
          }

          return searchItemName.indexOf(searchQuery) !== -1;

          // return thisPost.keyword_search.indexOf(searchQuery) !== -1;
        });
      },

      filterByCategory () {
        if (!this.category) {
          return;
        }

        if (this.category !== 'all') {
          this.filteredList = this.filteredList.filter(post => {
            this.resetVisible = true;

            let thisPost = post;

            let targetCategory = this.category;

            // Create collection for the counties of this post
            let categoryCollection = collect(thisPost.filterable_categories);

            return thisPost.filterable_categories.map(cat => cat.slug).indexOf(targetCategory) !== -1;
          });
        }
      },
      sortFilteredList () {
        if (!this.sortMethod) {
          return;
        }

        if (this.sortMethod !== 'none') {

          switch ( this.sortMethod ) {
            case 'a-z':

              this.filteredList = this.filteredList.sort(function(a, b) {
                return a.title > b.title ? 1 : -1;
              });

              break;

            case 'z-a':

              this.filteredList = this.filteredList.sort(function(a, b) {
                return a.title > b.title ? -1 : 1;
              });

              break;

            case 'newest-first':

              this.filteredList = this.filteredList.sort(function(a, b) {
                var dateA = new Date(a.date).getTime();
                var dateB = new Date(b.date).getTime();
                return dateA > dateB ? 1 : -1;
              });

              break;

            case 'oldest-first':

              this.filteredList = this.filteredList.sort(function(a, b) {
                var dateA = new Date(a.date).getTime();
                var dateB = new Date(b.date).getTime();
                return dateA > dateB ? -1 : 1;
              });

              break;
          }

        }
      }

    }
  };
</script>



// WEBPACK FOOTER //
// src/js/vue/site-search.vue